import React, {useState} from 'react';
import {useAppSelector} from "../../creator-presets/DAL/store";
import PluginIcon from "../../../../ui/svg/common/plugin";
import CpuIcon from "../../../../ui/svg/common/cpu";
import MacroIcon from "../../../../ui/svg/common/macro";
import HeartIcon from "../../../../ui/svg/common/heart";
import {setUserLikeClick} from "../../common/DAL/data-service";
import {UserLikeResponse} from "../../common/interfaces";

const LikesPluginsMacros = () => {

    const mainPreset = useAppSelector((store) => store.mainPreset);
    const [isUserLiked, setIsUserLiked] = useState(mainPreset.isUserLike);
    const [presetLikeCount, setPresetLikeCount] = useState(mainPreset.likesCount);
    const [isLikeLoading, setIsLikeLoading] = useState(false);

    const userLikeClick = async () => {
        if(isLikeLoading) return;
        setIsLikeLoading(true);
        let response = null;
        try {
            response = await setUserLikeClick(mainPreset.presetGUID);
        }
        catch(ex){}
        if(response?.data && response.data.isValid && response.data.relatedData){
            setPresetLikeCount((response.data.relatedData as UserLikeResponse).likeObj.result);
            setIsUserLiked(!isUserLiked);
            setIsLikeLoading(false);

        }else if(response && response.statusCode && response.statusCode === 401){
            window.location.href = "/login?returnurl=" + window.location.pathname;
            setIsLikeLoading(false);
            return;
        }
    }
    const getHeartColor = () => {
        if(isUserLiked){
            return "red";
        }
        return "black";
    }
    return (
        <div className="flex items-center py-4 text-sm">
            <div className="pr-3">
                <div className="flex items-center justify-center">
                    <div className="pt-1 pr-1 pb-1.5 ">
                        <PluginIcon width="13px" />
                    </div>
                    <div className="pr-1">{mainPreset.pluginCount}</div>
                    <span>Plugins</span>
                </div>
            </div>
            <div className="px-3">
                <div className="flex items-center justify-center">
                    <div className="pt-1 pr-1 ">
                        <MacroIcon width="12px" />
                    </div>
                    <div className="pr-1">{mainPreset.marcosCount}</div>
                    <span>Macros</span>
                </div>
            </div>

                {mainPreset.cpuMeter.length > 0 ?
                    <div className="px-3">
                        <div className="flex items-center justify-center">
                            <div className="pt-1 pr-1 pb-1 ">
                                <CpuIcon width="15px" />
                            </div>
                            <div className="pr-1">{mainPreset.cpuMeter}</div>
                            <span>CPU</span>
                        </div>
                    </div>
                    :<></>
                }


            <div className="hidden md:block px-3">|</div>
            <div className="px-3">
                <div className="flex items-center justify-center">
                    <div>{presetLikeCount}</div>
                    <button aria-label={`Add like to ${mainPreset.presetName}`} className="pl-1 cursor-pointer" onClick={userLikeClick}>
                        <HeartIcon isColorFill={isUserLiked} width={isUserLiked ? "14px":"15px"} color={getHeartColor()}/>
                    </button>
                </div>
            </div>
        </div>
    )
};

export default LikesPluginsMacros;